/**
 * Pitch (9-5-2) — rules options.
 *
 * The point scheme is fixed (PLAN.md decision 2): Bonanza-style, 18 points a
 * hand — High 1, Low 1, Jack 1, Game 1, the Five of trumps 5, the Nine of
 * trumps 9. What stays configurable is the handful of rulings the sources
 * genuinely disagree about (docs/rules/pitch.md §4 and the appendix), with the
 * defaults proposed in ARCHITECTURE.md §10.1 #5.
 */
export const DEFAULT_PITCH_CONFIG = {
    target: 52,
    minBid: 3,
    lowGoesTo: 'taker',
    gameTie: 'nobody',
    dealerMayMatch: true,
    stuckDealer: true,
    trumpIn: 'anytime',
};
/** Every point on offer in one hand: High, Low, Jack, Game, Five, Nine. */
export const PITCH_POINTS_PER_HAND = 18;
export const PITCH_CARDS_EACH = 6;
export const PITCH_TRICKS_PER_HAND = 6;
const ONE_OF = (values) => (v) => typeof v === 'string' && values.includes(v);
/** Partial, forgiving merge over the defaults, the same contract as 500's:
 *  a client may send only the fields it changes, and unknown keys are ignored
 *  so that adding an option later cannot break an old client. */
export function validatePitchConfig(raw) {
    if (raw === undefined || raw === null)
        return { ok: true, config: DEFAULT_PITCH_CONFIG };
    if (typeof raw !== 'object')
        return { ok: false, error: 'config must be an object' };
    const r = raw;
    const out = { ...DEFAULT_PITCH_CONFIG };
    const errors = [];
    const str = (key, guard, allowed) => {
        if (r[key] === undefined)
            return;
        if (!guard(r[key]))
            errors.push(`${key} must be one of ${allowed}`);
        else
            out[key] = r[key];
    };
    const int = (key, min, max) => {
        if (r[key] === undefined)
            return;
        const v = r[key];
        if (typeof v !== 'number' || !Number.isInteger(v) || v < min || v > max) {
            errors.push(`${key} must be an integer in [${min}, ${max}]`);
        }
        else
            out[key] = v;
    };
    const bool = (key) => {
        if (r[key] === undefined)
            return;
        if (typeof r[key] !== 'boolean')
            errors.push(`${key} must be a boolean`);
        else
            out[key] = r[key];
    };
    int('target', 11, 500);
    int('minBid', 1, PITCH_POINTS_PER_HAND);
    str('lowGoesTo', ONE_OF(['taker', 'holder']), "'taker' | 'holder'");
    str('gameTie', ONE_OF(['nobody', 'pitcher']), "'nobody' | 'pitcher'");
    str('trumpIn', ONE_OF(['anytime', 'ifVoid']), "'anytime' | 'ifVoid'");
    bool('dealerMayMatch');
    bool('stuckDealer');
    if (errors.length > 0)
        return { ok: false, error: errors.join('; ') };
    return { ok: true, config: out };
}
//# sourceMappingURL=config.js.map